export default __webpack_public_path__ + "static/media/345D.e7fee2b3.jpg";